import React, { useEffect, useState } from "react";
import Container from "../../UI/Container";
import { Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";
import DataProfile from "../../UI/DateProfile";
import TextFieldDate from "../../UI/TextFieldDate";
import dayjs from "dayjs";
import { findContadorPresencaAlunoByPresencaDataGroupByLegendaDiario } from "../api-presenca-aluno";

const useStyles = makeStyles({
  paper: {
    padding: "20px",
  },
  title: {
    marginBottom: "20px",
  },
});

const ContadorPresencaAlunoPorDataContainer = () => {
  const classes = useStyles();
  const [dataCalendar, setDataCalendar] = useState(null);
  const [listCPA, setListCPA] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataCalendar) {
      setIsLoading(true);
      findContadorPresencaAlunoByPresencaDataGroupByLegendaDiario(
        dataCalendar,
      ).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setListCPA(data);
          }
        }
        setIsLoading(false);
      });
    }
  }, [dataCalendar]);

  const handleTrocaDataCalendar = () => {
    setDataCalendar(null);
  };

  const handleDataChange = (dataElement) => {
    setDataCalendar(dayjs(dataElement));
  };

  return (
    <Container className={classes.paper} component={Paper}>
      <Grid container direction="column" spacing={3}>
        <Grid>
          <Typography className={classes.title} variant="h6">
            Contador Presença Aluno por Data
          </Typography>
        </Grid>
        {dataCalendar ? (
          <>
            <Grid>
              <DataProfile
                dataCalendar={dataCalendar}
                handleTrocaDataCalendar={handleTrocaDataCalendar}
              />
            </Grid>
            <Grid>
              {isLoading ? (
                <Loading description="Carregando Contador Presença Aluno..." />
              ) : (
                <>
                  {listCPA.map((cpa) => (
                    <div>
                      <div>
                        {cpa.legendaDiario.descricao} - {cpa.quantidade}
                      </div>
                    </div>
                  ))}
                </>
              )}
            </Grid>
          </>
        ) : (
          <Grid>
            <TextFieldDate
              required
              label="Data"
              value={dataCalendar ? dataCalendar : null}
              onChange={handleDataChange}
            />
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default ContadorPresencaAlunoPorDataContainer;
